import { render, staticRenderFns } from "./PolizasSGTabs.vue?vue&type=template&id=2dc44aa4&scoped=true&"
import script from "./PolizasSGTabs.vue?vue&type=script&lang=js&"
export * from "./PolizasSGTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc44aa4",
  null
  
)

export default component.exports